import { useQuery } from 'react-query';
import { api } from '../api';

export interface IExtractComprovanteProps {
  sacadoBanco: string;
  sacadoAgencia: string;
  sacadoConta: string;
  dtTransacao: string;
  vlMovimento: number;
  meioPagamento: string;
  autenticacao: string;
  favDocto: string;
  favNome: string;
  favBanco: string;
  favBancoNome: string;
  favTipoConta: string;
  favAgencia: string;
  favConta: string;
};

interface IParams {
  docto: string;
  id: string;
}

export async function getComprovante(
  params: IParams
): Promise<IExtractComprovanteProps> {
  const { data } = await api.get('transactions/extratoComprovante', {
    params
  });

  return data;
}

export function useComprovante(params: IParams) {
  return useQuery(
    [
      params.docto,
      params.id,
    ],
    () => getComprovante({ ...params }), {
    staleTime: Infinity,
    enabled: String(api.defaults.headers.common.authorization).length > 10 && !!params.docto,
    retry: 2
  });
}
